import { useTranslation } from "react-i18next";
import "./informationCard.scss";
import { useEffect, useRef, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import { CalendarIcon } from "../../../assets/svgIcon/customIcon";
import { ChevronLeft, ChevronRight, X } from "react-feather";

interface InformationCardProps {
  shippingAddress?: any;
  billingAddress?: any;
  userInfo?: any;
  setCustomeFromValue?: any;
  customerInfo?: any;
}
type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];
const InformationCard: React.FC<InformationCardProps> = ({
  shippingAddress,
  billingAddress,
  userInfo,
  setCustomeFromValue,
  customerInfo,
}) => {
  const { t } = useTranslation();
  // const monthRef = useRef<HTMLInputElement>(null);
  // const yearRef = useRef<HTMLInputElement>(null);
  // const dayRef = useRef<HTMLInputElement>(null);
  // const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.value.length >= 2) {
  //     setCustomeFromValue((prevState: any) => ({
  //       ...prevState,
  //       day: e.target.value,
  //     }));
  //     monthRef.current?.focus();
  //   }
  // };
  // const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.value.length >= 2) {
  //     setCustomeFromValue((prevState: any) => ({
  //       ...prevState,
  //       month: e.target.value,
  //     }));

  //     yearRef.current?.focus();
  //   }
  // };

  // const handleYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.value.length <= 4) {
  //     setCustomeFromValue((prevState: any) => ({
  //       ...prevState,
  //       year: e.target.value,
  //     }));

  //     e.target.value.length === 4 && yearRef.current?.blur();
  //   }
  // };

  // useEffect(() => {
  //   if (
  //     customerInfo &&
  //     customerInfo.day &&
  //     customerInfo.month &&
  //     customerInfo.year
  //   ) {
  //     // Ensure day and month are always two digits
  //     const formattedDay = customerInfo.day.padStart(2, "0");
  //     const formattedMonth = customerInfo.month.padStart(2, "0");
  //     setCustomeFromValue((prevState: any) => ({
  //       ...prevState,
  //       dob: `${customerInfo.year}-${formattedMonth}-${formattedDay}`,
  //     }));
  //   }
  // }, [customerInfo?.day, customerInfo?.month, customerInfo?.year]);

  const [value, onChange] = useState<Value>();
  useEffect(() => {
    // Handle the different possible types of `value`
    let formattedDate = "";
    if (value instanceof Date) {
      // If `value` is a single Date object
      formattedDate = moment(value).format("YYYY/MM/DD");
    } else if (Array.isArray(value)) {
      // If `value` is a tuple, handle accordingly (e.g., take the first date)
      const [startDate, endDate] = value;
      if (startDate) {
        formattedDate = moment(startDate).format("YYYY/MM/DD");
      }
    }

    setCustomeFromValue((prevState: any) => ({
      ...prevState,
      dob: formattedDate,
    }));
  }, [value]);

  return (
    <div className="information-card">
      <img
        className="img-fluid info-card-icon"
        src="./images/R-Logo-light.svg"
        alt="R-Logo-Light"
      />

      {userInfo?.firstName && userInfo?.lastName ? (
        <div className="card-data">
          <label>{t("name")}</label>
          <p>
            {userInfo?.firstName} {userInfo?.lastName}{" "}
            {userInfo?.secondLastName}
          </p>
        </div>
      ) : (
        <div className="information-card-form">
          <div className="row">
            <div className="col-sm-6">
              <div className="card-data first-name mb-3">
                <FloatingLabel controlId="floatingFirstName" label="First Name">
                  <Form.Control
                    type="text"
                    className="mb-0"
                    placeholder="First Name"
                    value={customerInfo.firstName}
                    maxLength={15}
                    onChange={(event: any) => {
                      const { value } = event.target;
                      const alphanumericPattern = /^[a-zA-Z\s]*$/;
                      if (alphanumericPattern.test(value)) {
                        setCustomeFromValue((prevState: any) => ({
                          ...prevState,
                          firstName: event.target.value,
                        }));
                      }
                    }}
                  />
                </FloatingLabel>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="card-data mb-3">
                <FloatingLabel controlId="floatingLastName" label="Last Name">
                  <Form.Control
                    type="text"
                    className="mb-0"
                    placeholder="Last Name"
                    maxLength={15}
                    value={customerInfo.lastName}
                    onChange={(event: any) => {
                      const { value } = event.target;
                      const alphanumericPattern = /^[a-zA-Z\s]*$/;
                      if (alphanumericPattern.test(value)) {
                        setCustomeFromValue((prevState: any) => ({
                          ...prevState,
                          lastName: event.target.value,
                        }));
                      }
                    }}
                  />
                </FloatingLabel>
              </div>
            </div>
          </div>
        </div>
      )}

      {userInfo?.dob ? (
        <div className="card-data">
          <label>{t("dob")}</label>
          <p>{userInfo?.dob}</p>
        </div>
      ) : (
        <>
          {/* <div className="information-card-form">
            <div className="dob-form">
              <FloatingLabel
                controlId="floatingDate"
                label="Date"
                className="ms-2"
              >
                <Form.Control
                  type="number"
                  placeholder="DD"
                  maxLength={2}
                  ref={dayRef}
                  onChange={handleDateChange}
                  className="mb-0 me-2" />
              </FloatingLabel>

              <div className="separate">{"/"}</div>
              <FloatingLabel
                controlId="floatingMonth"
                label="Month"
                className="mx-2"
              >
                <Form.Control
                  type="number"
                  placeholder="MM"
                  maxLength={2}
                  onChange={handleMonthChange}
                  ref={monthRef}
                  className="" />
              </FloatingLabel>
              <div className="separate">{"/"}</div>
              <FloatingLabel
                controlId="floatingYear"
                label="Year"
                className="me-2"
              >
                <Form.Control
                  type="number"
                  placeholder="YYYY"
                  maxLength={4}
                  ref={yearRef}
                  onChange={handleYearChange}
                  className="" />
              </FloatingLabel>
            </div>
        </div> */}
          <div className="information-card-form information-captured-datepicker">
            <DatePicker
              onChange={onChange}
              value={value}
              format="dd/MM/yyyy"
              maxDate={
                new Date(new Date().setFullYear(new Date().getFullYear() - 18))
              } // Set the max date to 18 years ago
              clearIcon={<X />}
              calendarIcon={<CalendarIcon />}
              required
              yearPlaceholder="YYYY"
              dayPlaceholder="DD"
              monthPlaceholder="MM"
            />
          </div>
        </>
      )}
      <div className="card-data">
        <label>{t("billing-address")}</label>
        {billingAddress ? <p>{billingAddress}</p> : <p> --- </p>}
      </div>
      <div>
        {shippingAddress && (
          <div className="card-data">
            <label>{t("shipping-address")}</label>
            <p>{shippingAddress}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InformationCard;
